import styled from "styled-components";

const StyleWrapper = styled.div`
    cursor: pointer;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 16px;
    border-radius: 8px;
    background: #FFFFFF;
    width:24%;
    margin:0 5px;    
    border: 1px solid #D9DCE1;
    &.active{
        background: ${props => props.businessColor ? props.businessColor : '#6B47F5'};
        border: 1px solid #D9DCE1;
        color: white;
        .info_wrapper{
            p{color: #fff;}
        }
    }
    .card_wrapper{
        display: flex;
        width: 100%;
        justify-content: center;
        gap: 1.5rem

    }
    .info_wrapper{
        display: inline-flex;
        flex-direction: column;
        gap: 0.25rem;
        .plate{
            font-weight: 800;
            font-size: 16px;
            line-height: 120%;
            color: #455560;
        }
        .price{
            font-weight: 400;
            font-size: 12px;
            line-height: 140%;
            color: #676F7C;
        }
    }
`;

export default StyleWrapper;